import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, Button } from '@mui/material'
import { AddCircle as AddCircleIcon } from '@mui/icons-material'
import { useDispatch } from 'react-redux'
import { showFormModal } from 'state/ui'
import FORM_MODALS from 'utils/ui/modals'

const SettingsReportWithBlade = ({
  title,
  subTitle,
  subTitle2,
  rowType,
  bladeTitle,
  bladeComponents,
  bladeActionOnSuccess,
  metaBaseEmbedComponent,
  fieldsToWatch,
}) => {
  const dispatch = useDispatch()

  const onClickOpenBlade = () => {
    dispatch(
      showFormModal({
        formModalName: FORM_MODALS.SETTINGS,
        formModalProps: {
          bladeTitle,
          bladeComponents,
          rowType,
          bladeActionOnSuccess,
          fieldsToWatch,
        },
      }),
    )
  }

  return (
    <>
      <Typography variant="h6" color="textPrimary">
        {title}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {subTitle}
      </Typography>
      {subTitle2 && (
        <Typography variant="body2" color="textSecondary">
          {subTitle2}
        </Typography>
      )}
      <Box mt={1}>
        <Button startIcon={<AddCircleIcon />} onClick={onClickOpenBlade}>
          {`Add ${rowType}`}
        </Button>
      </Box>
      {metaBaseEmbedComponent}
    </>
  )
}

SettingsReportWithBlade.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  subTitle2: PropTypes.string,
  rowType: PropTypes.string.isRequired,
  bladeTitle: PropTypes.string.isRequired,
  bladeComponents: PropTypes.array,
  bladeActionOnSuccess: PropTypes.string.isRequired,
  metaBaseEmbedComponent: PropTypes.element,
  fieldsToWatch: PropTypes.array,
}

SettingsReportWithBlade.defaultProps = {
  subTitle2: '',
  bladeComponents: [],
  metaBaseEmbedComponent: null,
  fieldsToWatch: [],
}

export default SettingsReportWithBlade
